import { Navigate, Route, Routes } from "react-router-dom";
// import { sendArrayToBackend } from "../socket/socketService";
import Home from "../components/Dashboard/Home";
import ProtectedLayout from "../layouts/ProtectedLayout";
import UnProtectedLayout from "../layouts/UnProtectedLayout";
import ProtectedRoute from "./ProtectedRoutes";
import ScrollToTop from "../common/ScrollToTop/ScrollToTop";
import Patientlist from "../components/Patient/Patientlist";
import Physician from "../components/physician/physician";
import Appointment from "../components/appointment/Appointments";
import ClinicTestMaster from "../components/clinicTestMaster/clinicTestMaster";
import ClinicLabProfile from "../components/clinicLabProfile/clinicLabProfile";
import Settings from "../components/Setting/Settings";
import MyProfile from "../components/Setting/MyProfile/MyProfile";
import HospitalInformation from "../components/Setting/HospitalInformation";
import Security from "../components/Setting/Security";
import Account from "../components/Setting/Account";
import AllPdf from "../components/Setting/AllPdf";
import InvoiceList from "../components/invoice/Invoice";
import InvoiceForm from "../components/invoice/InvoiceForm";
import PhysicianDetails from "../components/physician/physicianDetails";
import ViewInvoice from "../components/invoice/viewInvoice";
import ClinicSkinServiceMaster from "../components/clinicSkinServiceMaster/ClinicSkinServiceMaster";
import ClinicHairServiceMaster from "../components/clinicHairServiceMaster/ClinicHairServiceMaster";
import ClinicGeneralServiceMaster from "../components/clinicGeneralServiceMaster/ClinicGeneralServiceMaster";
import ClinicDentalTestMaster from "../components/clinicDentalTestMaster/ClinicDentalTestMaster";
import LabReport from "../components/labReport/labReport";
import ViewLabReport from "../components/labReport/viewLabReport";
import LabReportPDF from "../components/labReport/labReportPdf";
import EditLabReport from "../components/labReport/editLabReport";
import UserProfile from "../components/UserProfile/UserProfile";
import Branch from "../components/branch/branch";
import RequestBranch from "../components/branch/branchrequest";
import ViewRadiologyReport from "../components/clinicRadiologyMaster/viewRadiologyReport";
import ClinicRadiologyMaster from "../components/clinicRadiologyMaster/clinicRadiologyMaster";
import RadiologyReport from "../components/clinicRadiologyMaster/report/radiologyReport";
import EditRadiologyReport from "../components/clinicRadiologyMaster/report/editRadiologyReport";
import Bank from "../components/bank/bank";
import ClinicUser from "../components/clinicUser/clinicUser";
import PackageMaster from "../components/packageMaster/PackageMaster";
import HealthScreening from "../components/healthScreening/HealthScreening";
import UnRegisteredClinic from "../components/unRegisteredClinic/UnRegisteredClinic";
import ClientType from "../components/ClientType/ClientType";
import Camp from "../components/camp/Camp";
import Client from "../components/client/client";
import Membership from "../components/membership/Membership";
import ClientBill from "../components/ClientPrice/ClientBill";
import ClientBillPdf from "../components/ClientPrice/ClientBillPdf";
import MisReport from "../components/misReport/MisReport";
import ClientPrice from "../components/ClientPrice/ClientPrice";
import Physiotherapy from "../components/physiotherapy/Physiotherapy";
import ReferrerList from "../components/ReferrerList/ReferrerList";
import MedicalCertificate from "../components/medicalCertificate/medicalCertificate";
import EditMedicalCertificate from "../components/medicalCertificate/editMedicalCertificate";
import ReferralCommission from "../components/ReferralCommission/referralCommission";
import ReferralCommissionPayment from "../components/ReferralCommission/referralCommissionPayment";
import Role from "../components/role/role";
import Setmodulerolepermission from "../components/role/setModuleRolePermission";
import Receipt from "../components/receipt/receipt";
import ReceiptForm from "../components/receipt/receiptForm";
import PhysicianPayment from "../components/physicianPayment/PhysicianPayment";
import PhysicianPaymentHistory from "../components/physicianPayment/physicianPaymentHistory/PhysicianPaymentHistory";
import ViewReceipt from "../components/receipt/receiptInvoice";
import MyCollection from "../components/invoice/myCollection";
import ViewPaymentVoucher from "../components/ReferralCommission/ViewPaymentVoucher";
import Curewell from "../components/Template/CurewellReport/Curewell";
import TataReport from "../components/Template/tataReport/tatareport";
import Supplier from "../components/supplier/supplier";
import Purchase from "../components/purchase/purchase";
import StockInventory from "../components/stockInventory/stockInventory";
import LowStock from "../components/stockInventory/lowStock";
import PharmaSales from "../components/pharmaSales/pharmaSales";
import PatientProfile from "../components/patientProfile/patientProfile";
import PharmaMyCollection from "../components/pharmaSales/pharmaMyCollection";
import ViewPharmaInvoice from "../components/pharmaSales/viewPharmaInvoice";
import PharmaSalesRetailer from "../components/pharmaSalesRetailer/pharmaSalesRetailer";
import PharmaRetailerMyCollection from "../components/pharmaSalesRetailer/pharmaRetailerMyCollection";
import Retailer from "../components/retailer/retailer";
import ViewPharmaRetailerInvoice from "../components/pharmaSalesRetailer/viewPharmaRetailerInvoice";
import PharmaSettlement from "../components/pharmaSettlement/pharmaSettlement";
import BiopsyTracking from "../components/biopsytracking/biopsy"
import ViewPrescription from "../components/appointment/viewPrescription";
import InvoiceReportPdf from "../components/invoice/InvoicereportPdf";
import ReceiptreportPdf from "../components/receipt/RecieptreportPdf";
import SampleCollection from "../components/sampleCollection/sampleCollection";
import ViewMedicalCertificate from "../components/medicalCertificate/editRadiologyReport/ViewMedicalCertificate";
import Phlebotomist from "../components/phlebotomist/phlebotomist";
export const protectedComponentRoutes = [
  { url: "home", component: <Home />, titel: "Home" },
  { url: "dashboard", component: <Home />, titel: "Dashboard" },
  { url: "patient", component: <Patientlist />, titel: "Patient List" },
  { url: "physician", component: <Physician />, titel: "Physician" },
  { url: "appointments", component: <Appointment />, titel: "Appointment" },
  { url: "labReport", component: <LabReport />, titel: "Lab Report" },
  { url: "invoice-report-pdf", component: <InvoiceReportPdf />, titel: "Invoice Report PDF" },
  { url: "receipt-report-pdf", component: <ReceiptreportPdf />, titel: "Receipt Report PDF" },
  {
    url: "clinicTestMaster",
    component: <ClinicTestMaster />,
    titel: "Clinic Test Master",
  },
  {
    url: "clinicLabProfile",
    component: <ClinicLabProfile />,
    titel: "Clinic Lab Profile",
  },
  { url: "settings", component: <Settings />, titel: "Settings" },
  { url: "profile-setting", component: <MyProfile />, titel: "My Profile" },
  {
    url: "hospital-information",
    component: <HospitalInformation />,
    titel: "Hospital Information",
  },
  { url: "security-info", component: <Security />, titel: "Security" },
  { url: "account-info", component: <Account />, titel: "Account" },
  { url: "pdf", component: <AllPdf />, titel: "PDF" },
  { url: "invoice", component: <InvoiceList />, titel: "Invoice List" },
  { url: "invoice-form", component: <InvoiceForm />, titel: "Invoice Form" },
  {
    url: "physicianDetails",
    component: <PhysicianDetails />,
    titel: "Physician Details",
  },
  { url: "view_invoice", component: <ViewInvoice />, titel: "View Invoice" },
  {
    url: "clinicDentalTestMaster",
    component: <ClinicDentalTestMaster />,
    titel: "Clinic Dental Test Master",
  },
  {
    url: "clinicSkinServiceMaster",
    component: <ClinicSkinServiceMaster />,
    titel: "Clinic Skin Service Master",
  },
  {
    url: "clinicHairServiceMaster",
    component: <ClinicHairServiceMaster />,
    titel: "Clinic Hair Service Master",
  },
  {
    url: "clinicGeneralServiceMaster",
    component: <ClinicGeneralServiceMaster />,
    titel: "Clinic General Service Master",
  },
  {
    url: "viewLabReport",
    component: <ViewLabReport />,
    titel: "View Lab Report",
  },
  { url: "labReportPdf", component: <LabReportPDF />, titel: "Lab Report PDF" },

  {
    url: "editLabReport",
    component: <EditLabReport />,
    titel: "Edit Lab Report",
  },
  { url: "userProfile", component: <UserProfile />, titel: "User Profile" },
  { url: "branch", component: <Branch />, titel: "Branch" },
  {
    url: "requestBranch",
    component: <RequestBranch />,
    titel: "Request Branch",
  },
  {
    url: "clinicRadiologyMaster",
    component: <ClinicRadiologyMaster />,
    titel: "Clinic Radiology Master",
  },
  {
    url: "radiologyReport",
    component: <RadiologyReport />,
    titel: "Radiology Report",
  },
  {
    url: "editRadiologyReport",
    component: <EditRadiologyReport />,
    titel: "Edit Radiology Report",
  },
  { url: "bank", component: <Bank />, titel: "Bank" },
  { url: "clinicUser", component: <ClinicUser />, titel: "Clinic User" },
  {
    url: "packageMaster",
    component: <PackageMaster />,
    titel: "Package Master",
  },
  {
    url: "healthScreening",
    component: <HealthScreening />,
    titel: "Health Screening",
  },
  {
    url: "unRegisteredClinic",
    component: <UnRegisteredClinic />,
    titel: "UnRegistered Clinic",
  },
  { url: "clientType", component: <ClientType />, titel: "Client Type" },
  { url: "camp", component: <Camp />, titel: "Camp" },
  { url: "client", component: <Client />, titel: "Client" },
  { url: "membership", component: <Membership />, titel: "Membership" },
  { url: "clientBill", component: <ClientBill />, titel: "Client Bill" },
  { url: "clientBillPdf", component: <ClientBillPdf />, titel: "Client Bill PDF" },
  { url: "misReport", component: <MisReport />, titel: "MIS Report" },
  { url: "clientPrice", component: <ClientPrice />, titel: "Client Price" },
  {
    url: "physiotherapy",
    component: <Physiotherapy />,
    titel: "Physiotherapy",
  },
  { url: "referrer", component: <ReferrerList />, titel: "Referrer" },
  {
    url: "medicalCertificate",
    component: <MedicalCertificate />,
    titel: "Medical Certificate",
  },
  {
    url: "editMedicalCertificate",
    component: <EditMedicalCertificate />,
    titel: "Edit Medical Certificate",
  },
  {
    url: "referralCommission",
    component: <ReferralCommission />,
    titel: "Referral Commission",
  },
  {
    url: "referralCommissionPayment",
    component: <ReferralCommissionPayment />,
    titel: "Referral Commission Payment",
  },
  { url: "role", component: <Role />, titel: "Role" },
  {
    url: "setmodulerolepermission",
    component: <Setmodulerolepermission />,
    titel: "Set Module Role Permission",
  },
  { url: "receipt", component: <Receipt />, titel: "Receipt" },
  { url: "receiptForm", component: <ReceiptForm />, titel: "Receipt Form" },
  {
    url: "physicianPayment",
    component: <PhysicianPayment />,
    titel: "Physician Payment",
  },
  {
    url: "physicianPaymentHistory",
    component: <PhysicianPaymentHistory />,
    titel: "Physician Payment History",
  },
  { url: "viewReceipt", component: <ViewReceipt />, titel: "View Receipt" },
  { url: "myCollection", component: <MyCollection />, titel: "My Collection" },
  { url: "curewell", component: <Curewell />, titel: "Curewell" },
  { url: "tatareport", component: <TataReport /> },
  { url: "supplier", component: <Supplier />, titel: "Supplier" },
  { url: "purchase", component: <Purchase />, titel: "Purchase" },
  {
    url: "stockInventory",
    component: <StockInventory />,
    titel: "StockInventory",
  },
  { url: "lowStock", component: <LowStock />, titel: "LowStock" },
  { url: "pharmaSales", component: <PharmaSales />, titel: "Pharma Sales" },
  {
    url: "patientProfile",
    component: <PatientProfile />,
    titel: "Patient Profile",
  },
  {
    url: "pharmaRetailerMyCollection",
    component: <PharmaRetailerMyCollection />,
    titel: "Pharma Retailer My Collection",
  },
  {
    url: "viewPharmaInvoice",
    component: <ViewPharmaInvoice />,
    titel: "View Pharma Invoice",
  },
  {
    url: "pharmaSalesRetailer",
    component: <PharmaSalesRetailer />,
    titel: "Pharma Sales Retailer",
  },
  {
    url: "PharmaMyCollection",
    component: <PharmaMyCollection />,
    titel: "Pharmacy Collection",
  },
  {
    url: "retailer",
    component: <Retailer />,
    titel: "Retailer",
  },
  {
    url: "viewPharmaRetailerInvoice",
    component: <ViewPharmaRetailerInvoice />,
    titel: "View Pharma Retailer Invoice",
  },
  {
    url: "pharmaSettlement",
    component: <PharmaSettlement />,
    titel: "Pharma Settlement",
  },
  {
    url: "biopsy",
    component: <BiopsyTracking />,
    titel: "Biopsy Tracking",
  },
  {
    url: "viewPrescription",
    component: <ViewPrescription />,
    titel: "View Prescription",
  },
    {
    url: "sampleCollection",
    component: <SampleCollection />,
    titel: "Sample Collection",
  },
  {
    url: "viewMedicalCertificate",
    component: <ViewMedicalCertificate />,
    titel: "View Medical Certificate",
  },
    {
    url: "phlebotomist",
    component: <Phlebotomist />,
    titel: "Phlebotomist"
  }
];

export const unProtectedComponentRoutes = [
  {
    url: "viewRadiologyReport",
    component: <ViewRadiologyReport />,
    titel: "View Radiology Report",
  },
  {
    url: "payment_voucher/:commissionId/:paymentDetailsId",
    component: <ViewPaymentVoucher />,
    titel: "View Payment Voucher",
  },
];


const ProtectedRouter = () => {
  return (
    <>
      <Routes>
        <Route element={<ProtectedLayout />}>
          {protectedComponentRoutes?.map((data, i) => (
            <Route
              key={i}
              exact
              path={`${data?.url}`}
              element={<ProtectedRoute>{data?.component}</ProtectedRoute>}
            />
          ))}
          <Route path="*" element={<Navigate to="/home" replace />} />
        </Route>
      </Routes>
      <ScrollToTop />
    </>
  );
};

const UnProtectedRouter = () => {

  return (
    <>
      <Routes>
        <Route element={<UnProtectedLayout />}>
          {unProtectedComponentRoutes?.map((data, i) => (
            <Route
              key={i}
              exact
              path={`${data?.url}`}
              element={data?.component}
            />
          ))}
        </Route>
      </Routes>
      <ScrollToTop />
    </>
  );
};

export { ProtectedRouter, UnProtectedRouter };
